import FirebaseConfig from "../firebaseConfig";

const db = FirebaseConfig.firestore(),
  mentorRef = db.collection("mentors");

// login mentor
export async function mentorLogin(data, callback) {
  try {
    const user = await mentorRef
      .where("email", "==", data)
      .where("status", "==", "active")
      .limit(1)
      .get();
    if (user) {
      localStorage.setItem("docid", user.docs[0].id);
      localStorage.setItem(
        "#name##",
        user.docs[0].first_name + " " + user.docs[0].last_name
      );
      callback(user.docs[0].data(), true);
    } else {
      callback({}, false);
    }
  } catch (error) {
    console.log("error  ", error);
    callback({}, false);
  }
}

// add value in mentors collection
export async function createMentor(data, callback) {
  let mentor = mentorRef.doc();
  mentor
    .set({
      id: mentor.id,
      status: "active",
      first_name: data.first_name,
      last_name: data.last_name,
      phone: data.phone,
      email: data.email,
      ethnicity: data.ethnicity,
      cohort_year: data.cohort_year,
      gender: data.gender,
      assigned_mentee: data.assigned_mentee,
      created_by: localStorage.getItem("token"),
      created_at: FirebaseConfig.firestore.FieldValue.serverTimestamp(),
    })
    .then(() => {
      callback(true);
    })
    .catch(() => {
      callback(false);
    });
}

// list mentors details
export async function getMentors(callback) {
  let mentors = [];
  mentorRef.get().then((querySnapshot) => {
    querySnapshot.forEach((doc) => {
      const {
        first_name,
        last_name,
        phone,
        email,
        ethnicity,
        cohort_year,
        gender,
        assigned_mentee,
        created_at,
        created_by,
        id,
        status,
      } = doc.data();
      mentors.push({
        key: doc.id,
        id,
        first_name,
        last_name,
        phone,
        email,
        ethnicity,
        cohort_year,
        gender,
        assigned_mentee,
        created_by,
        created_at,
        status,
      });
    });
    callback(mentors);
  });
}

// update value in mentors collection
export async function updateMentor(data, callback) {
  try {
    await mentorRef.doc(data.id).set({
      first_name: data.first_name,
      last_name: data.last_name,
      phone: data.phone,
      email: data.email,
      ethnicity: data.ethnicity,
      cohort_year: data.cohort_year,
      created_by: localStorage.getItem("token"),
      created_at: FirebaseConfig.firestore.FieldValue.serverTimestamp(),
    });
    callback({}, true);
  } catch (error) {
    callback({}, false);
  }
}

export async function getMentorProfile(docId) {
  let uid = localStorage.getItem("token");
  uid = uid ? uid : FirebaseConfig.auth().currentUser.uid;
  localStorage.setItem("token", uid);
  try {
    const user = await mentorRef.doc(docId ? docId : uid).get();
    return user.data();
  } catch (error) {
    console.log("error  ", error);
    return false;
  }
}

export async function removeMentor(userId, callback) {
  try {
    await mentorRef.doc(userId).delete();
    callback({}, true);
  } catch (error) {
    console.log(error);
    callback({}, false);
  }
}

export async function updateStatus(data, status, callback) {
  try {
    await mentorRef.doc(data.id).set({
      ...data,
      status: status,
    });
    callback({}, true);
  } catch (error) {
    callback({}, false);
  }
}
export async function getMentorInfo(id, callback) {
  console.log(id);
  try {
    const user = await mentorRef.where("id", "==", id).get();
    console.log(user);
    if (user) {
      callback(user.docs[0].data(), true);
    } else {
      callback({}, false);
    }
  } catch (error) {
    console.log("error  ", error);
    callback({}, false);
  }
}
